var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-nav mb-4"},_vm._l((_vm.maxSteps),function(step,index){return _c('li',{key:index,class:{'current' : _vm.currentStep === index + 1}},[_c('a',{attrs:{"href":""}},[_vm._v(" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }